export default {
    baseURL: 'https://server.ritzfloor.ca/api',
    backendURL: 'https://server.ritzfloor.ca/'
}



// https://server.ritzfloor.ca
// https://ritzfloor.techjainsupport.co.in